import React from 'react'
import AppRoutes from "../AppRoutes";
import ScrollToTop from '../components/scrollTop';

const Index = () => {
  return (
    <>
      {/* <ScrollToTop /> */}
      <AppRoutes></AppRoutes>
    </>
  )
}

export default Index;
